import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistJA() {
  const articleData = {
    title: 'あなたの元カレは隠れナルシシストですか？（テキストは嘘をつかない）',
    description: 'あなたの元カレが隠れナルシシストかどうか疑問に思っていますか？当社のAIがテキストメッセージで即座に検出する7つの微妙な操作的行動を発見してください。',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector 編集部'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '隠れナルシシストとは何ですか？また、あからさまなナルシシストとどう違いますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '隠れナルシシストは、明白であからさまなナルシシストとは異なり、魅力、微妙な感情的戦術、受動的攻撃的なメッセージの背後に操作的な行動を隠します。'
      }
    }, {
      '@type': 'Question',
      name: 'AIはテキストメッセージで隠れナルシシズムを検出できますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい。Toxic Detectorは、トーン、罪悪感の誘発、ラブボミングのサイクル、矛盾、感情操作のパターンを分析して、隠れナルシシストの行動にフラグを立てます。'
      }
    }, {
      '@type': 'Question',
      name: 'テキストでの隠れナルシシストの一般的な行動は何ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '感情操作、ガスライティング、受動的攻撃的なコメント、被害者を演じること、ラブボミングとその後の撤回、微妙なコントロールなどです。'
      }
    }, {
      '@type': 'Question',
      name: '隠れナルシシストから身を守るにはどうすればよいですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'メッセージを記録し、直感を信じ、境界線を維持し、Toxic Detectorのようなツールを使用して操作的なパターンを客観的に特定してください。'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('リンクがクリップボードにコピーされました！');
    }
  };
  return <>
      <MetaTags title="あなたの元カレは隠れナルシシストですか？AIが操作を検出する方法 | ToxicDetector" description="あなたの元カレが隠れナルシシストかどうか疑問に思っていますか？当社のAIが即座に検出する7つの微妙な操作的行動を発見してください。" keywords="隠れナルシシストの兆候, 隠されたナルシシストの行動, ナルシシストの操作テキスト, AIナルシシスト検出器" canonical={`https://toxicdetector.com/ja/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-7529" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7530">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-7531">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-7532">
            <div className="flex items-center justify-between" data-id="element-7533">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-7534">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="記事を共有" data-id="element-7535">
                <Share2 size={20} className="text-gray-600" data-id="element-7536" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-7537">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-7538">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7539" />
            ブログに戻る
          </Link>

          <header className="mb-12" data-id="element-7540">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-7541">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7542">
              <time dateTime={articleData.publishDate} data-id="element-7543">
                {new Date(articleData.publishDate).toLocaleDateString('ja-JP', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7544">•</span>
              <span data-id="element-7545">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-7546">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="AIを使用して隠れナルシシストの操作の兆候についてテキストメッセージを分析する女性" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-7547" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-7548">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-7549">目次</h2>
            <ul className="space-y-3 text-sm" data-id="element-7550">
              <li data-id="element-7551">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7552">
                  <span className="text-gray-400" data-id="element-7553">→</span> 1.
                  すべてのメッセージにおける感情操作
                </a>
              </li>
              <li data-id="element-7554">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7555">
                  <span className="text-gray-400" data-id="element-7556">→</span> 2.
                  徐々に構築されるガスライティング
                </a>
              </li>
              <li data-id="element-7557">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7558">
                  <span className="text-gray-400" data-id="element-7559">→</span> 3.
                  受動的攻撃的なコメント
                </a>
              </li>
              <li data-id="element-7560">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7561">
                  <span className="text-gray-400" data-id="element-7562">→</span> 4. 常に被害者を演じる
                </a>
              </li>
              <li data-id="element-7563">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7564">
                  <span className="text-gray-400" data-id="element-7565">→</span> 5.
                  ラブボミングとその後の撤回
                </a>
              </li>
              <li data-id="element-7566">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7567">
                  <span className="text-gray-400" data-id="element-7568">→</span> 6.
                  隠されたコントロールと監視
                </a>
              </li>
              <li data-id="element-7569">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7570">
                  <span className="text-gray-400" data-id="element-7571">→</span> 7.
                  チャネル間の不一致なトーン
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-7572">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7573">
              元カレが魅力的で思いやりがあるように見えながら、舞台裏であなたを操作していたと感じたことはありますか？それは
              <strong data-id="element-7574">隠れナルシシストの典型的な兆候</strong>
              です。明白なナルシシストとは異なり、隠れナルシシストは微妙な感情的戦術の背後に操作を隠します。
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-7575">
              当社の<strong data-id="element-7576">AIは隠された操作を検出</strong>
              し、テキストを分析するだけで即座に識別します。その方法は以下の通りです。
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-7577">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7578">
                1️⃣ すべてのメッセージにおける感情操作
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7579">
                隠れナルシシストは感情をねじ曲げて自分の思い通りにします。
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7580">
                <p className="italic text-gray-700 text-lg" data-id="element-7581">
                  「君がこれで怒るなんて信じられない...」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7582">
                AIは、日常のメッセージに隠された微妙な罪悪感の誘発や感情的な圧力を検出します。
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-7583">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7584">
                2️⃣ 徐々に構築されるガスライティング
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7585">
                <p className="italic text-gray-700 text-lg" data-id="element-7586">
                  「君はそれを間違って覚えている...」
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7587">
                隠れナルシシストはあなた自身の記憶を疑わせます。AIは現実が歪められている繰り返しの事例にフラグを立てます。
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-7588">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7589">
                3️⃣ 受動的攻撃的なコメント
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7590">
                <p className="italic text-gray-700 text-lg" data-id="element-7591">
                  「もちろん、君が幸せなら何でもいいよ...」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7592">
                受動的攻撃性は隠れナルシシズムの特徴です。AIは皮肉、陰湿な当てこすり、隠された敵意を認識します。
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-7593">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7594">
                4️⃣ 常に被害者を演じる
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7595">
                <p className="italic text-gray-700 text-lg" data-id="element-7596">
                  「君のためにこれだけしてあげたのに...」
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7597">
                隠れナルシシストはしばしば責任を転嫁し、自分自身を被害者に仕立て上げます。AIはあなたに罪悪感を感じさせるように設計されたフレーズを検出します。
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-7598">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7599">
                5️⃣ ラブボミングとその後の撤回
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7600">
                <p className="italic text-gray-700 text-lg" data-id="element-7601">
                  「君は僕が愛した唯一の人だ 😢」 → 音信不通
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7602">
                激しい愛情の後に感情的な距離が続くこの古典的なサイクルは危険信号です。AIは複数のチャットにわたってこれらのパターンを識別します。
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-7603">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7604">
                6️⃣ 隠されたコントロールと監視
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7605">
                <p className="italic text-gray-700 text-lg" data-id="element-7606">
                  「ちょっと確認しただけ...また」
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7607">
                ケアを装った微妙なコントロールは隠れた戦術です。AIは明白な攻撃性なしに繰り返されるチェック行動にフラグを立てます。
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-7608">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7609">
                7️⃣ チャネル間の不一致なトーン
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7610">
                <p className="italic text-gray-700 text-lg" data-id="element-7611">
                  グループチャット: 遊び心 / 1対1: 批判的
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7612">
                隠れナルシシストはしばしば公の場では行動を隠し、私的には操作します。AIは会話を比較して不一致を強調します。
              </p>
            </section>

            <section className="mb-12" data-id="element-7613">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7614">
                🛡 自分を守る方法
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-7615">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-7616">
                  <li className="flex items-start gap-3" data-id="element-7617">
                    <span className="text-purple-600 font-bold" data-id="element-7618">•</span>
                    <span data-id="element-7619">
                      直感を信じてください。危険信号を無視しないでください。
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7620">
                    <span className="text-purple-600 font-bold" data-id="element-7621">•</span>
                    <span data-id="element-7622">
                      明確にするためにスクリーンショットを保存してください。
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7623">
                    <span className="text-purple-600 font-bold" data-id="element-7624">•</span>
                    <span data-id="element-7625">友人やセラピストと経験を共有してください。</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7626">
                    <span className="text-purple-600 font-bold" data-id="element-7627">•</span>
                    <span data-id="element-7628">
                      Toxic
                      Detectorのようなツールを使用してパターンを特定してください。
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-7629">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7630">
                💀 自分の目で確かめる
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7631">
                隠れナルシシズムは見つけるのが難しいかもしれませんが、AIは見逃しません。チャットをアップロードして即座に分析を取得してください：
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-7632">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-7633">
                  "🚩 78% 操作を検出。隠れた戦術が特定されました！"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-7634">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7635">
                よくある質問
              </h2>
              <div className="space-y-4" data-id="element-7636">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-7637">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-7638">
                      <span data-id="element-7639">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-7640" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-7641">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-7642">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7643">
              💀 真実を明らかにする準備はできましたか？
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7644">
              推測するのはやめましょう。テキストをToxic
              Detectorにアップロードして、即座に毒性スコアを取得してください。当社のAIは、あなたが見逃したかもしれない隠れた操作を明らかにします。
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-7645">
              <p className="font-bold text-xl" data-id="element-7646">
                "🚩 78% 操作を検出。隠れた戦術が特定されました！"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-7647">
              今すぐチャットをスキャン →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'AIが即座に検知するガスライティングの7つの兆候',
          description: 'AIがテキスト会話で検出する主要なガスライティングパターンを学びます。',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: '受動的攻撃的なテキストへの究極のガイド',
          description: 'テキストメッセージでの受動的攻撃的な行動と隠された操作を見つけます。',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-7648" />

          <div className="mt-12 text-center" data-id="element-7649">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-7650">
              <Share2 size={18} className="mr-2" data-id="element-7651" />
              この記事を共有
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-7652">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-7653">
            <p className="text-gray-500 text-sm" data-id="element-7654">
              © {new Date().getFullYear()} ToxicDetector. 全著作権所有。
            </p>
          </div>
        </footer>
      </div>
    </>;
}